// UI constants for the RegistrationModal.
// NOTE: the country list is NOT here — it comes from the backend /api/config
// as the single source of truth for purchase routing. Do not duplicate the
// country list on the frontend.

export const USER_PROFILES = [
  { value: "individual_reader", label: "Individual reader" },
  { value: "psychodrama_professional", label: "Psychodrama professional" },
  { value: "other_professional", label: "Other professional" },
  { value: "researcher_academic", label: "Researcher / academic" },
  { value: "other", label: "Other" },
];

// Privacy accountability constants.
// PRIVACY_POLICY_VERSION must match the version documented in the
// Privacy Policy page. Bump when the policy is revised.
export const PRIVACY_POLICY_VERSION = "v1.0-2026-08-27";

export const ACKNOWLEDGMENT_TEXT =
  "By clicking \"KEEP ME INFORMED & CONTINUE TO AMAZON\", you confirm you have read the " +
  "Privacy Policy and understand that the information you provide will be processed to " +
  "fulfil your request: to direct you to the appropriate Amazon marketplace, to send you " +
  "the information needed to verify your copy of Self Doubling, and to enable access to " +
  "the verified-reader platform after verification.";
